import React from "react";
import { Car, Cpu, Cog, Dumbbell, Factory, Stethoscope } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Stagger, itemVariant } from "../components/Reveal";
import { INDUSTRIES } from "../data/content";

const ICONS = { Car, Cpu, Cog, Dumbbell, Factory, Stethoscope };

export default function Industries() {
  const { t, lang, pick } = useLang();
  return (
    <>
      <Seo title="Branchen – Automobil, Elektronik, Maschinenbau | PlastoNord TPU"
        description="PlastoNord beliefert Automobilbau, Elektronik, Maschinenbau, Sport & Freizeit, Medizintechnik und allgemeine Industrie mit TPU und technischen Kunststoffen."
        path="/branchen" />
      <PageHero overline={t("nav.industries")}
        title={lang === "de" ? "Branchen, die auf unsere Materialien vertrauen" : "Industries that trust our materials"}
        subtitle={lang === "de" ? "Von der Automobilindustrie bis zur Medizintechnik – technische Kunststoffe für anspruchsvolle Anwendungen." : "From automotive to medical – technical plastics for demanding applications."} />
      <section className="py-24">
        <div className="pn-container">
          <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind) => { const Icon = ICONS[ind.icon]; const c = pick(ind); return (
              <motion.div key={c.t} variants={itemVariant} className="pn-card p-7">
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-[#16181D] text-white"><Icon size={22} /></span>
                <h3 className="mt-5 font-head text-xl font-semibold text-[#16181D]">{c.t}</h3>
                <p className="mt-2 leading-relaxed text-[#4a4d52]">{c.d}</p>
              </motion.div>
            ); })}
          </Stagger>
        </div>
      </section>
    </>
  );
}
